
document.addEventListener('DOMContentLoaded',()=>{
  const slides = document.querySelectorAll('.hero .slides img');
  let i=0;
  function show(n){ slides.forEach((im,idx)=>im.classList.toggle('active', idx===n)); }
  if(slides.length){ show(0); setInterval(()=>{ i=(i+1)%slides.length; show(i); }, 4000); }
});


// GrabTheCollectionCTAOverride
document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll('.bundle-cta').forEach(function(el) {
    el.addEventListener('click', function(e) {
      if (el.textContent.match(/grab|collection|buy|checkout|cart/i)) {
        e.preventDefault();
        window.location.href = "/cart/45738986602649:1?checkout";
      }
    });
  });
});


// UpdateCTAButtonTextOverride
document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll('.bundle-cta').forEach(function(el) {
    if (el.textContent.match(/grab|collection|buy|checkout|cart/i)) {
      el.textContent = "Grab the Collection, only $49";
    }
  });
});
